var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 29.8452V17.975C0 17.0385 0.781921 16.2793 1.74649 16.2793C2.71106 16.2793 3.49298 17.0385 3.49298 17.975V29.8452C3.49298 30.2949 3.67702 30.7262 4.00455 31.0442C4.33208 31.3622 4.77632 31.5409 5.23952 31.5409H29.6906C30.1538 31.5409 30.598 31.3622 30.9256 31.0442C31.2531 30.7262 31.4371 30.2949 31.4371 29.8452V17.975C31.4371 17.0385 32.219 16.2793 33.1836 16.2793C34.1482 16.2793 34.9301 17.0385 34.9301 17.975V29.8452C34.9301 31.1944 34.3781 32.4883 33.3955 33.4424C32.4129 34.3964 31.0802 34.9324 29.6906 34.9324H5.23952C3.84992 34.9324 2.51721 34.3964 1.53461 33.4424C0.552005 32.4883 0 31.1944 0 29.8452Z",
    fill: "#06362B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2782 0.452299C16.9583 -0.160495 18.0176 -0.15061 18.6854 0.481958L25.8461 7.26489C26.5365 7.91889 26.5501 8.99248 25.8766 9.66283C25.203 10.3332 24.0972 10.3464 23.4068 9.69244L17.4657 4.06476L11.5247 9.69244C10.8343 10.3464 9.72856 10.3332 9.05498 9.66283C8.3814 8.99248 8.39505 7.91888 9.08547 7.26489L16.2462 0.481958L16.2782 0.452299Z",
    fill: "#06362B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7188 24.7577V5.25676C15.7188 4.32023 16.5007 3.56104 17.4652 3.56104C18.4298 3.56104 19.2117 4.32023 19.2117 5.25676V24.7577C19.2117 25.6942 18.4298 26.4535 17.4652 26.4535C16.5007 26.4535 15.7188 25.6942 15.7188 24.7577Z",
    fill: "#06362B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0be3ab3336f0ff9c5b3a45d9d8e25a2e.svg";
export { ForwardRef as ReactComponent };